module.exports = __webpack_public_path__ + "static/media/study 201128.fdc4540e.png";